export const hasHTMLDialogElementSupport = () => {
  if (typeof window === `undefined`) return false;
  return Boolean(window.HTMLDialogElement);
};
